<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      d="m12 3 .6.1.2.1.3.4v.1h.1l2.7 5 3.9-3.2.8-.4a1.4 1.4 0 0 1 1.3 1v.7l-2.5 9.3a2 2 0 0 1-1.8 1.3H6.4a2 2 0 0 1-1.7-1.2v-.1L2 6.9V6h.1q.2-.4.5-.6h.1a1 1 0 0 1 1.4 0h.1l4 3.3 2.6-5 .5-.5q.4-.3.7-.2M9.8 9.6a2 2 0 0 1-2 .9q-.4 0-.7-.4l-3-2.3 2.2 7.8h11.2l2.2-7.8-2.7 2.3a1.8 1.8 0 0 1-2.8-.5L12 5.3zm8.6 9.6q.8 0 .9.9t-1 .9H5.7q-.8 0-.9-.9t1-.9z"
    />
  </svg>
</template>
